import React, {Component} from "react";
import Modal from "components/Modal";
import SelectField from "components/forms/SelectField";
import {Button, MenuItem} from "@material-ui/core";
import {ExpandedBooking} from "services/entities/booking";
import {Design} from "services/entities/designs";
import {formatBookingDate, formatBookingTime} from "util/booking";
import {loadDesigns} from "services/designs";
import {handleError} from "util/errors";
import {updateBookingDesign} from "services/bookings";
import './index.scss';
import ProgressSpinner from "components/ProgressSpinner";

interface BookingDesignModalProps {
  open: boolean;
  onCancelled: ()=>void;
  onSaved: ()=>void;
  booking: ExpandedBooking|null;
}

interface BookingDesignModalState {
  designs: Design[]|null;
  selectedDesign: string|null;
  saving: boolean;
}

export default class BookingDesignModal extends Component<BookingDesignModalProps, BookingDesignModalState> {
  state: BookingDesignModalState = {
    designs: null,
    selectedDesign: null,
    saving: false
  };

  componentDidMount() {
    if(this.props.open && this.props.booking) {
      this.setState({selectedDesign: this.props.booking.design?.code || null});
      this.loadDesigns(this.props.booking);
    }
  }

  componentDidUpdate(prevProps: Readonly<BookingDesignModalProps>, prevState: Readonly<BookingDesignModalState>, snapshot?: any) {
    if(this.props.open && this.props.booking && (prevProps.open !== this.props.open || prevProps.booking !== this.props.booking)) {
      this.setState({designs: null, selectedDesign: this.props.booking.design?.code || null, saving: false});
      this.loadDesigns(this.props.booking);
    }
  }

  render() {
    const {open, booking} = this.props;
    const {designs, selectedDesign, saving} = this.state;
    return <Modal className="booking-design-modal" open={!!(booking && open)} closable={true} onClosing={this.onClose}>
      {booking && <>
        <h2>Import a design for {booking.space.name}</h2>
        <p>Import one of your existing designs</p>
        <div className="fields">
          <div className="location">
            <span className="label">Where</span>
            <span className="value">{ booking.space.name }</span>
          </div>
          <div className="date">
            <span className="label">When</span>
            <span className="value">{ formatBookingDate(booking) }, { formatBookingTime(booking) }</span>
          </div>
        </div>
        <label>Select design to import</label>
        <SelectField disabled={!designs || designs!.length === 0 || saving} onChange={this.onDesignChanged}
                     placeholder={designs && designs!.length === 0 ? 'No designs available' : undefined}
                     value={selectedDesign}>
          { designs && designs!.map(des => <MenuItem key={des.code} value={des.code}>{ des.name }</MenuItem>) }
        </SelectField>
        <div className="design-space-note">You can only import designs that were made for the same location</div>
        <Button className="submit" disabled={saving || !selectedDesign} onClick={this.onSaveDesign}>
          { saving && <ProgressSpinner /> }
          Import design
        </Button>
      </>}
    </Modal>;
  }

  loadDesigns(booking: ExpandedBooking) {
    loadDesigns({space: booking.space.code}).then(
      designs => this.setState({designs: designs}),
      ex => {
        handleError("Loading designs failed", ex);
        this.props.onCancelled();
      }
    );
  }

  onClose = () => {
    this.props.onCancelled();
  };

  onDesignChanged = (designCode: string) => {
    this.setState({selectedDesign: designCode});
  };

  onSaveDesign = () => {
    this.setState({saving: true});
    updateBookingDesign(this.props.booking!.code, this.state.selectedDesign!).then(
      () => {
        this.setState({saving: false});
        this.props.onSaved();
      },
      ex => {
        this.setState({saving: false});
        handleError('Failed to update booking', ex);
      }
    );
  };
}